import { ExportOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useState } from 'react';
import clx from 'classnames';
import ExportModal from './export-modal';

function Export({ className }) {
  const [open, setOpen] = useState(false);

  const handleExport = () => {
    setOpen(true);
  };

  return (
    <>
      <Button
        id="export"
        type="link"
        onClick={handleExport}
        className={clx('reconciliation-list__setting-btn', className)}
      >
        <ExportOutlined style={{ color: '#38B2A6' }} />
        <p className="reconciliation-list__export_text">Export</p>
      </Button>
      <ExportModal setOpen={setOpen} open={open} />
    </>
  );
}

export default Export;
